import Utils from '../../Utils';

const focusableElements = '[href], button, summary, input, select, textarea, [tabindex]:not([tabindex="-1"])';

export default class Modal {

    static initializeEvents() {
        Array.from(document.querySelectorAll('dialog.modal')).forEach(modal => {
            modal.addEventListener('click', event => {
                // Si la modale est ouverte et que l'on clique en dehors de la zone de contenu, la modale se ferme
                if (event.target.closest('.modal-content') === null) {
                    this.closeAllOpenedModals();
                    this.enableBodyScroll();
                }
            });

            Array.from(document.querySelectorAll('[aria-controls="' + modal.id + '"]')).forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    const currentModal = document.getElementById(event.currentTarget.getAttribute('aria-controls'));

                    // Si la modale est ouverte, celle-ci est fermée. Sinon, celle-ci est ouverte
                    if (currentModal.hasAttribute('open')) {
                        currentModal.close()
                        this.enableBodyScroll();
                    } else {
                        if (document.querySelectorAll('dialog.modal[open]').length) {
                            this.closeAllOpenedModals();
                        } else {
                            this.disableBodyScroll();
                        }

                        currentModal.show();
                        setTimeout(() => currentModal.querySelector('.modal-content button').focus(), 100);
                    }
                });
            });
        });

        window.addEventListener('keydown', event => {
            if (event.defaultPrevented) {
                return;
            }

            // Lors du clic sur la touche "Echap" du clavier, on ferme toutes les modales
            if (event.key === 'Escape') {
                this.closeAllOpenedModals();
                this.enableBodyScroll();
            }

            // Lors du clic sur la touche "Flèche gauche" du clavier, la modale précédente est ouverte
            if (event.key === 'ArrowLeft') {
                const openedModal = document.querySelector('dialog.modal[open]');
                if (openedModal) {
                    this.openLinkedModal(openedModal, 'Précédent');
                }
            }

            // Lors du clic sur la touche "Flèche droite" du clavier, la modale suivante est ouverte
            if (event.key === 'ArrowRight') {
                const openedModal = document.querySelector('dialog.modal[open]');
                if (openedModal) {
                    this.openLinkedModal(openedModal, 'Suivant');
                }
            }

            // Lors du clic sur la touche "Tabulation" du clavier, le focus est restreint aux éléments de la modale ouverte
            if (event.key === 'Tab') {
                const modal = Utils.parent(document.activeElement, 'dialog.modal[open]');
                if (modal) {
                    const focusableContent = modal.querySelectorAll(focusableElements);
                    const firstFocusableElement = focusableContent[0];
                    const lastFocusableElement = focusableContent[focusableContent.length - 1];

                    if (event.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus();
                            event.preventDefault();
                        }
                    } else {
                        if (document.activeElement === lastFocusableElement) {
                            firstFocusableElement.focus();
                            event.preventDefault();
                        }
                    }
                }
            }
        });
    }

    static disableBodyScroll() {
        document.querySelector('html').style.overflow = 'hidden';
    }

    static enableBodyScroll() {
        document.querySelector('html').style.overflow = 'auto';
    }

    static closeAllOpenedModals() {
        Array
            .from(document.querySelectorAll('dialog.modal[open]'))
            .forEach(modal => modal.close());
    }

    static openLinkedModal(modal, direction) {
        const linkedModalButton = modal.querySelector('[aria-controls][title="' + direction + '"]');
        if (linkedModalButton) {
            const linkedModal = document.getElementById(linkedModalButton.getAttribute('aria-controls'));
            if (linkedModal) {
                this.closeAllOpenedModals();

                linkedModal.show();
                setTimeout(() => linkedModal.querySelector('.modal-content button').focus(), 100);
            }
        }
    }

}